import React from "react";

const AppCard = ({ children, className = "" }) => (
  <section
    className={`rounded-[1.65rem] border border-white/75 bg-white/[0.82] shadow-[0_0.9rem_2rem_rgba(15,23,42,0.08)] backdrop-blur dark:border-slate-700/80 dark:bg-slate-900/80 dark:shadow-black/20 ${className}`}
  >
    {children}
  </section>
);

export default AppCard;
